import Button from "components/Button/index";
import useTheme from "hooks/observer";
import { useEffect } from "react";
import "./logoutmodal.scss";
import useScreenMobile from "hooks/useScreen";
// import { log } from "../../../../node_modules/cspell/dist/esm/console";
const LogoutModal = ({
  setLogoutModal = () => {},
  title = "Are you sure you want to log out?",
  logoutHandler = () => {}
}) => {
  const theme = useTheme();
  const isMobile = useScreenMobile({ size: 768 });

 useEffect(() => {
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      // console.log("Enter key pressed");
      logoutHandler(); // Call logout when Enter is pressed
    }
  };

  window.addEventListener("keydown", handleKeyDown);

  return () => {
    window.removeEventListener("keydown", handleKeyDown);
  };
}, [logoutHandler]);

  return (
    <div className="logoutModal">
      <div className="logoutContainer">
        <div className="icon">
          <div className="svg">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path
                d="M14 8V6C14 5.46957 13.7893 4.96086 13.4142 4.58579C13.0391 4.21071 12.5304 4 12 4H5C4.46957 4 3.96086 4.21071 3.58579 4.58579C3.21071 4.96086 3 5.46957 3 6V18C3 18.5304 3.21071 19.0391 3.58579 19.4142C3.96086 19.7893 4.46957 20 5 20H12C12.5304 20 13.0391 19.7893 13.4142 19.4142C13.7893 19.0391 14 18.5304 14 18V16M9 12H21M21 12L18 9M21 12L18 15"
                stroke={theme === "dark" ? "#BE2828" : "#DC1818"}
                strokeWidth="2.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
        </div>
        <p className="title">{title}</p>
        <div className="footer">
          <Button
            title="Cancel"
            type="white"
            width={isMobile ? "100%" : "20%"}
            onClick={() => setLogoutModal(false)}
          />
          <Button
            title="Logout"
            type="delete"
            width={isMobile ? "100%" : "20%"}
            onClick={logoutHandler}
          />
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;
